import { DropdownPanelMenu } from '@/shared/components/dropdowns/DropdownPanel';
import OverflowFadeScrollArea from '@/shared/components/layouts/OverflowFadeScrollArea';
import type { OverflowFadeSurface } from '@/shared/components/layouts/OverflowFadeScrollArea';

import useAccountSwitcherItems from './index';

interface AccountWorkspaceSectionProps {
    disabled?: boolean;
    surface?: OverflowFadeSurface;
    showMostRecent?: boolean;
}

/** The account list owns scrolling; surrounding dropdown/login actions stay outside it. */
export default function AccountWorkspaceSection({
    disabled,
    surface = 'elevated',
    showMostRecent = false,
}: AccountWorkspaceSectionProps) {
    const items = useAccountSwitcherItems({ section: 'accounts', disabled, showMostRecent });
    return (
        <OverflowFadeScrollArea aria-label='Signed-in accounts' surface={surface} style={{ maxHeight: '15rem' }}>
            <DropdownPanelMenu
                aria-label='Account workspaces'
                disabled={disabled}
                selectable={false}
                style={{ padding: 0 }}
            >
                {items}
            </DropdownPanelMenu>
        </OverflowFadeScrollArea>
    );
}
